import styled, { keyframes } from 'styled-components'

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`

export const StyledSpinner = {
  Wrapper: styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100vw;
    height: var(--full-height, 100vh);
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  `,

  Svg: styled.svg`
    shape-rendering: auto;
    display: block;
    background: rgba(0, 0, 0, 0);
  `,
  Circle: styled.circle`
    transform-origin: center;
    animation: ${spin} 2s linear infinite;
  `,
}
